import axios from "axios";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useIdleTimer } from 'react-idle-timer';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  // State to hold the authentication token
  const [token, setToken_] = useState(localStorage.getItem("token"));

  // Function to set the authentication token
  const setToken = (newToken) => {
    if (newToken) {
      localStorage.setItem('token', newToken);
      axios.defaults.headers.common["access_token"] = "Bearer " + newToken;
    } else {
      localStorage.removeItem('token');
      delete axios.defaults.headers.common["access_token"];
    }
    setToken_(newToken);
  };

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem('userinfo');
    localStorage.removeItem('role');
    window.location.href = "/logout";
  };

  // react-idle-timer measures keyboard and pointer input, not whether the page
  // is doing anything. Every screen here used to be click-driven, so ten
  // minutes was invisible; the wireless console is the first one designed to be
  // watched — a live survey or a thirty-minute capture holds an operator's
  // attention without touching an input device, and they were being logged out
  // mid-test.
  //
  // Twenty minutes is a compromise, not a fix. The right answer is to warn
  // before logging out rather than to keep lengthening the window, because a
  // secops console left unattended should still lock.
  useIdleTimer({
    timeout: 20 * 60 * 1000,
    onIdle: handleLogout,
    debounce: 500
  });

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common["access_token"] = "Bearer " + token;
      localStorage.setItem('token',token);
    } else {
      delete axios.defaults.headers.common["access_token"];
      localStorage.removeItem('token')
    }
  }, [token]);

  // Memoized value of the authentication context
  const contextValue = useMemo(
    () => ({
      token,
      setToken,
    }),
    [token]
  );

  // Provide the authentication context to the children components
  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthProvider;